import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Abstract } from '@/module/Author/Abstract';
import { AbstractValidationAction } from '@/module/Author/Abstract/Validation/AbstractValidationAction';
import { AbstractCard } from '@/module/Author/Abstract/components/Card/AbstractCard';

interface CollapsableAbstractProps {
  title: string;
  abstracts: Abstract[];
}

export function CollapsableAbstract({ title, abstracts }: CollapsableAbstractProps) {
  return (
    <CollapsableGroup
      title={title}
      items={abstracts}
      renderValidation={abstract => (
        <AbstractValidationAction
          variant="compact"
          abstractId={abstract.id}
        />
      )}
      renderItem={abstract => (
        <AbstractCard
          abstract={abstract}
          onClick={() => window.open(`/author/abstract/${abstract.id}`)}
        />
      )}
    />
  );
}
